import { useState } from "react";

import {    
    passwordValidator,
    usernameValidator
} from "../validators";

import { useLocalization } from "@progress/kendo-react-intl";

const touchErrors = (errors: any) => {
    return Object.entries(errors).reduce((acc: any, [field, fieldError]) => {
        if (typeof fieldError === 'object' && fieldError !== null) {
            acc[field] = {
                ...fieldError,
                dirty: true,
            };
        } else {
            acc[field] = {
                dirty: true,
            };
        }
        return acc;
    }, {});
};

export const useLoginFormValidator = (form: any) => {

    const localizationService = useLocalization();

    const [errors, setErrors] = useState({
        username: {
            dirty: false,
            error: false,
            message: "",
        },
        password: {
            dirty: false,
            error: false,
            message: "",
        },
        //email: {
        //    dirty: false,
        //    error: false,
        //    message: "",
        //},
        //confirmPassword: {
        //    dirty: false,
        //    error: false,
        //    message: "",
        //},
    });

    interface FormData {
        username: string;
        password: string;
        //email: string;
        //confirmPassword?: string;
    }

    const validateForm = ({ form, field, errors, forceTouchErrors = false }: { form: FormData, field?: string, errors: any, forceTouchErrors?: boolean }) => {
        let isValid = true;

        // Create a deep copy of the errors
        let nextErrors: any = JSON.parse(JSON.stringify(errors));

        // Force validate all the fields
        if (forceTouchErrors) {
            nextErrors = touchErrors(errors);
        }

        //const { email, password, confirmPassword } = form;        
        const { username, password } = form;

        if (nextErrors.username.dirty && (field ? field === "username" : true)) {
            let usernameMessage: any = usernameValidator(username);
            if(usernameMessage === "Username is required"){
                usernameMessage = localizationService.toLanguageString('login_error.usernameEmpty', 'NOT_FOUND')
            }else{
                usernameMessage = usernameValidator(username)
            }
            nextErrors.username.error = !!usernameMessage;
            nextErrors.username.message = usernameMessage;
            if (!!usernameMessage) isValid = false;
        }
        
        if (nextErrors.password.dirty && (field ? field === "password" : true)) {
            let passwordMessage: any = passwordValidator(password);
            if(passwordMessage === "Password must have a minimum 8 characters"){
                passwordMessage = localizationService.toLanguageString('login_error.passwordValidator', 'NOT_FOUND')
            }else if(passwordMessage === "Password is required"){
                passwordMessage = localizationService.toLanguageString('login_error.passwordEmpty', 'NOT_FOUND')
            }else{
                passwordMessage = passwordValidator(password)
            }
            nextErrors.password.error = !!passwordMessage;
            nextErrors.password.message = passwordMessage;
            if (!!passwordMessage) isValid = false;
        }
        //if (nextErrors.email.dirty && (field ? field === "email" : true)) {
        //    const emailMessage: any = emailValidator(email);
        //    nextErrors.email.error = !!emailMessage;
        //    nextErrors.email.message = emailMessage;
        //    if (!!emailMessage) isValid = false;
        //}

        //if (
        //    nextErrors.confirmPassword.dirty &&
        //    (field ? field === "confirmPassword" : true)
        //) {
        //    const confirmPasswordMessage = confirmPasswordValidator(
        //        confirmPassword,
        //        form
        //    );
        //    nextErrors.confirmPassword.error = !!confirmPasswordMessage;
        //    nextErrors.confirmPassword.message = confirmPasswordMessage;
        //    if (!!confirmPasswordMessage) isValid = false;
        //}

        setErrors(nextErrors);

        return {
            isValid,
            errors: nextErrors,
        };
    };

    const onBlurField = (e: any) => {
        const field = e?.target?.name as keyof typeof errors;
        const fieldError = errors[field];
        if (fieldError.dirty) return;

        const updatedErrors: any = {
            ...errors,
            [field]: {
                ...errors[field],
                dirty: true,
            },
        };

        validateForm({ form, field, errors: updatedErrors });
    };

    return {
        validateForm,
        onBlurField,
        errors,
    };
};